/**
 * The DSP click macro both the Motionly port and the static/rich click path
 * substitute at click time. Centralised here so the literal and the
 * replacement live in one place.
 *
 * The helper does a GLOBAL substitution and performs NO encoding — the caller
 * decides whether to encodeURIComponent the token before passing it in.
 */

/** The `${DC_DBM_TOKEN}` click macro literal. */
export const DC_DBM_TOKEN = '${DC_DBM_TOKEN}';

/**
 * Replace every `${DC_DBM_TOKEN}` occurrence in `url` with `token`.
 * Returns `url` unchanged when `token` is falsy (the macro is left in place,
 * never blanked). No encoding is applied.
 */
export function replaceDcDbmToken(url: string, token: string): string {
  if (!token) {
    return url;
  }
  // split/join = global replace without a regex and without encoding surprises.
  return url.split(DC_DBM_TOKEN).join(token);
}
